<template>
 
  <div id="app">
        <carInsurenceWidget />
  </div>
</template>

<script>
import carInsurenceWidget from './components/carInsurenceWidget.vue'

document.title = 'Sammenlign priser på bilforsikring'

export default {
  name: 'App',
  components: {
    carInsurenceWidget,
  },
  methods:{
  buttonClickedHandler(testdata){
this.testdatasend = testdata;
  },
    loanPeriodDataUpdatedHandler(testdata2){
this.testdatasend2 = testdata2;
  }
  }

}
</script>

<style>

@font-face {
  font-family: 'proxima-nova';
  src: url('./assets/ProximaNova-Regular.otf'); /* IE9 Compat Modes */
  }

#app {
  font-family: proxima-nova, "Helvetica Neue", Helvetica, "Microsoft JhengHei", "Open Sans", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.app-container{
   border-style:solid;
  border-width:1px;
  border-color:#EFEFEF;
  border-radius:6px;
  background: white;
  margin-left:0vw;
  width:100%;
  -webkit-box-shadow: 0 1px 8px 0 rgb(0 0 0 / 15%); 
  box-shadow: 0 1px 8px 0 rgb(0 0 0 / 15%);
}


.app-container a{
  display: block;
  text-align:center;
  font-size:0.77em;
  font-weight:600;
  color:#519BC6;
}

</style>
